export default __webpack_public_path__ + "static/media/05.ea413009.jpg";